$(document).ready(function () {
  // Function to check if an element is in the viewport
  function isInViewport(element) {
    let rect = element.getBoundingClientRect();
    let windowHeight =
      window.innerHeight || document.documentElement.clientHeight;
    let windowWidth = window.innerWidth || document.documentElement.clientWidth;

    // Calculate the total area of the element
    let elementArea = rect.width * rect.height;

    // Calculate the area of the element that is within the viewport
    let visibleHeight =
      Math.min(windowHeight, rect.bottom) - Math.max(0, rect.top);
    let visibleWidth =
      Math.min(windowWidth, rect.right) - Math.max(0, rect.left);
    let visibleArea = Math.max(0, visibleWidth) * Math.max(0, visibleHeight);

    // Calculate the percentage of the element that is visible
    let visiblePercentage = (visibleArea / elementArea) * 100;

    // Return true if at least 50% of the element is visible
    return visiblePercentage >= 70;
  }

  // On scroll event
  $(window).on("scroll", function () {
    $("div.collection-carousel").each(function () {
      if (isInViewport(this)) {
        $(".collection-nav-item-wrapper").removeClass("active-wrap");
        $("#nav_" + this.id).addClass("active-wrap");
      }
    });
  });

  // Trigger scroll event on page load to check initial visibility
  $(window).trigger("scroll");
});

const navItems = document.querySelector(".nav-items");
let isDragging = false;
let startX;
let scrollLeft;

// Function to handle touch events and simulate mouse events
function touchHandler(event) {
  const touch = event.changedTouches[0];
  let simulatedEvent;
  switch (event.type) {
    case "touchstart":
      simulatedEvent = new MouseEvent("mousedown", {
        bubbles: true,
        cancelable: true,
        view: window,
        screenX: touch.screenX,
        screenY: touch.screenY,
        clientX: touch.clientX,
        clientY: touch.clientY,
      });
      navItems.dispatchEvent(simulatedEvent);
      break;
    case "touchmove":
      simulatedEvent = new MouseEvent("mousemove", {
        bubbles: true,
        cancelable: true,
        view: window,
        screenX: touch.screenX,
        screenY: touch.screenY,
        clientX: touch.clientX,
        clientY: touch.clientY,
      });
      navItems.dispatchEvent(simulatedEvent);
      break;
    case "touchend":
      simulatedEvent = new MouseEvent("mouseup", {
        bubbles: true,
        cancelable: true,
        view: window,
        screenX: touch.screenX,
        screenY: touch.screenY,
        clientX: touch.clientX,
        clientY: touch.clientY,
      });
      navItems.dispatchEvent(simulatedEvent);
      break;
    default:
      return;
  }
  // Prevent default touch behavior ==> event.preventDefault();
}

// Add event listeners for touch events
navItems.addEventListener("touchstart", touchHandler, true);
navItems.addEventListener("touchmove", touchHandler, true);
navItems.addEventListener("touchend", touchHandler, true);
navItems.addEventListener("touchcancel", touchHandler, true);

// Existing mouse event handlers
navItems.addEventListener("mousedown", (e) => {
  e.preventDefault();
  isDragging = true;
  navItems.style.cursor = "grabbing";
  startX = e.clientX;
  scrollLeft = navItems.scrollLeft;
  // Disable click events during drag
  navItems.addEventListener("click", disableClick, true);
});

navItems.addEventListener("mouseleave", () => {
  if (isDragging) {
    // Re-enable click events after drag
    navItems.removeEventListener("click", disableClick, true);
  }
  isDragging = false;
  navItems.style.cursor = "grab";
});

navItems.addEventListener("mouseup", () => {
  if (isDragging) {
    // Re-enable click events after drag
    navItems.removeEventListener("click", disableClick, true);
  }
  isDragging = false;
  navItems.style.cursor = "grab";
});

navItems.addEventListener("mousemove", (e) => {
  if (!isDragging) return;
  e.preventDefault();
  const x = e.clientX;
  const walk = (x - startX) * 1; // Adjust scrolling speed
  navItems.scrollLeft = scrollLeft - walk;
});

// Function to disable click events during drag
function disableClick(e) {
  e.stopImmediatePropagation();
  e.preventDefault();
}
